<template>
  <a-modal title="新增标签"
           :visible="isAddTagModalVisible"
           :confirm-loading="pointTagconfirmLoading"
           @ok="addTaghandleOk"
           okText="保 存"
           cancelText="取 消"
           @cancel="addTaghandleCancel"
           width="892px">
    <a-transfer :data-source="addTagList"
                :target-keys="targetKeys"
                :show-search="true"
                :filter-option="
        (inputValue, item) => item.description.indexOf(inputValue) !== -1 ||item.title.indexOf(inputValue) !== -1
      "
                :show-select-all="false"
                @change="onChangeTransfer"
                :titles="['标签库', '已选标签']"
                placeholder="请输入标签组名称"
                >
                
      <template slot="children"
                slot-scope="{
          props: {
            direction,
            filteredItems,
            selectedKeys,
            disabled: listDisabled,
          },
          on: { itemSelectAll, itemSelect },
        }">
        <a-table :row-selection="
            getRowSelection({
              disabled: listDisabled,
              selectedKeys,
              itemSelectAll,
              itemSelect,

            },direction)
          "
                 :columns="
            direction === 'left' ? addTagLeftColumns : addTagRightColumns
          "
                 :data-source="filteredItems"
                 size="small"
                 :style="{ pointerEvents: listDisabled ? 'none' : null }"
                 :custom-row="
            ({ key, disabled: itemDisabled }) => ({
              on: {
                click: () => {
                  if (itemDisabled || listDisabled) return
                  itemSelect(key, !selectedKeys.includes(key))
                },
              },
            })
          ">
          <template slot="description"
                    slot-scope="text, record, index">
            <a-tag>{{ text }}</a-tag>
          </template>
        </a-table>
      </template>
    </a-transfer>
  </a-modal>
</template>

<script>
import api from '../../commomFun/api.js'
import difference from 'lodash/difference'

export default {
  props: {
    isAddTagModalVisible: Boolean,
    pointTagModalId: Number,
  },
  data() {
    return {
      //新增标签 穿梭框左边列表
      addTagList: [],
      currentAddTagList: [], //用于全选所有
      targetKeys: [],
      currentTargetKeys: [],
      pointTagconfirmLoading: false,
      addTagLeftColumns: [
        {
          dataIndex: 'title',
          title: '所属标签组',
          ellipsis:true,
          width: 120,
        },
        {
          dataIndex: 'description',
          title: '标签',
          ellipsis:true,
          width: 120,
          scopedSlots: {
            customRender: 'description',
          },
        },
      ],
      addTagRightColumns: [
        {
          dataIndex: 'title',
          title: '所属标签组',
          ellipsis:true,
          width: 120,
        },
        {
          dataIndex: 'description',
          title: '标签',
          ellipsis:true,
          width: 120,
          scopedSlots: {
            customRender: 'description',
          },
        },
      ],
    }
  },
  mounted() {
    this.getTags({
      pointId: this.pointTagModalId,
      pageSize: 10000,
      pageNum: 1,
    })
  },
  methods: {
    getTags(params) {
      this.targetKeys = []
      this.currentTargetKeys = []
      this.addTagList = []
      api
        .getApi(`/tag/getPointTagList`, params)
        .then((res) => {
          if (res.data.code == 200) {
            let data = res.data.data.list
            data.forEach((item) => {
              this.addTagList.push({
                key: item.id.toString(),
                title: item.groupName || '--',
                description: item.name,
                disabled: false,
              })
              if (item.selectFlag) {
                this.targetKeys.push(item.id.toString())
                this.currentTargetKeys.push({
                  key: item.id.toString(),
                  title: item.groupName || '--',
                  description: item.name,
                  disabled: false,
                })
              } else {
                this.currentAddTagList.push({
                  key: item.id.toString(),
                  title: item.groupName || '--',
                  description: item.name,
                  disabled: false,
                })
              }
            })
            // this.currentAddTagList = JSON.parse(JSON.stringify(this.addTagList))
          } else {
            this.$message.error(res.data.msg || `获取标签失败`)
          }
        })
        .catch((e) => {
          this.$message.error(`获取标签失败`)
        })
    },
    addTaghandleOk() {
      let params = {
        pointId: this.pointTagModalId,
        tagIds: this.targetKeys,
      }
      this.updataSelectTags(params)
    },
    updataSelectTags(params) {
      api
        .putApi(`/tag/updatePointTag`, params)
        .then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg || `保存成功`)
            this.$emit('upDateChange')
          } else {
            this.$message.error(res.data.msg || `保存失败`)
          }
        })
        .catch((e) => {
          this.$message.error(res.data.msg || `保存失败`)
        })
        .finally((_) => {
          // this.isAddTagModal = false
          this.$emit('update:isAddTagModalVisible', false)
        })
    },
    addTaghandleCancel() {
      // this.isAddTagModal = false
      this.$emit('update:isAddTagModalVisible', false)
    },
    onChangeTransfer(nextTargetKeys) {
      this.targetKeys = nextTargetKeys
      // 用于右边列表全选
      this.currentTargetKeys = nextTargetKeys.map((item) => {
        return this.addTagList.filter((i) => {
          return i.key == item
        })[0]
      })
      // 用于左边列表全选
      let data = JSON.parse(JSON.stringify(this.addTagList))
      nextTargetKeys.forEach((item) => {
        const index = data.findIndex((i) => {
          return i.key == item
        })
        data.splice(index, 1)
      })
      this.currentAddTagList = data
    },

    getRowSelection(
      { disabled, selectedKeys, itemSelectAll, itemSelect },
      direction
    ) {
      let that = this
      return {
        getCheckboxProps: (item) => ({
          props: { disabled: disabled || item.disabled },
        }),
        onSelectAll(selected, selectedRows) {
          // 是点击左边全选还是右边全选
          let allSelectData =
            direction == 'left'
              ? that.currentAddTagList
              : that.currentTargetKeys

          const treeSelectedKeys = selected
            ? allSelectData
                .filter((item) => !item.disabled)
                .map(({ key }) => key)
            : []
          const diffKeys = selected
            ? difference(treeSelectedKeys, selectedKeys)
            : difference(selectedKeys, treeSelectedKeys)
          itemSelectAll(diffKeys, selected)
        },
        onSelect({ key }, selected) {
          itemSelect(key, selected)
        },
        selectedRowKeys: selectedKeys,
      }
    },
  },
}
</script>

<style scoped lang="scss">
</style>